import { API_LOAN_POOL, API_LOAN_POOL_BY_ID, API_LOAN_POOL_BY_LOAN_ID } from 'config'
import Api from 'services/api'

export const filterPools = (filterQuery: Record<string, any>) => {
  return Api.get(API_LOAN_POOL, filterQuery)
}

export const createPool = (data: Record<string, any>) => {
  return Api.post(API_LOAN_POOL, data)
}

export const removePool = (id: number) => {
  return Api.delete(API_LOAN_POOL_BY_ID, {}, { id })
}

export const removePoolLoan = (id: number, loanID: number) => {
  return Api.delete(API_LOAN_POOL_BY_LOAN_ID, {}, { id, loanID })
}

export const getPoolByID = (id: number) => {
  return Api.get(API_LOAN_POOL_BY_ID, {}, { id })
}

export const restorePoolLoans = (id: number, loanIDs: string[]) => {
  return Api.put(API_LOAN_POOL_BY_ID, loanIDs, { id })
}

export const updatePoolLoanField = (id: number, loanID: any, data: Record<string, any>) => {
  return Api.put(API_LOAN_POOL_BY_LOAN_ID, data, { id, loanID })
}
